(function ($) {
    'use strict';
    $(function () {
        const modal = $('.newsletter-popup');

        if (!modal.length) {
            return;
        }

        if (!Cookies.get("newsletter_popup_closed")) {
            modal.removeClass('is-closed');
        }

        $('.js-close-newsletter-popup').on('click', function () {
            Cookies.set('newsletter_popup_closed', true, { expires: 1 });
            modal.addClass('is-closed');
        });

        $('.js-open-newsletter-popup').on('click', function () {
            modal.addClass('is-wider');
            $('.newsletter-popup__subscribe-screen').addClass('is-active')
            $('.newsletter-popup__default-screen').removeClass('is-active');
        });
    });
})(jQuery);